module.exports = __webpack_public_path__ + "img/11n.9501c73b.png";